export const Configuration = {
  API_HOST: process.env.API_HOST,
  API_TIMEOUT: 600000,
  BASIC_AUTH_USER_NAME: process.env.BASIC_AUTH_USER_NAME,
  BASIC_AUTH_PASSWORD: process.env.BASIC_AUTH_PASSWORD,
  BASIC_AUTH_ON_API: process.env.BASIC_AUTH_ON_API,
  GA_MEASUREMENT_ID: process.env.GA_MEASUREMENT_ID,
  GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
  LP_URL: process.env.LP_URL,
}

export const ErrorMessages = {
  NO_AUTHORIZATION: 'NO_AUTHORIZATION',
  NO_PARAMETER_SEARCH_JOB: 'NO_PARAMETER_SEARCH_JOB',
  NO_PARAMETER_SEARCH_GROUPING_JOB: 'NO_PARAMETER_SEARCH_GROUPING_JOB',
  NO_PARAMETER_SEARCH_COMPANY: 'NO_PARAMETER_SEARCH_COMPANY',
  NO_PARAMETER_SEARCH_CORPORATION: 'NO_PARAMETER_SEARCH_CORPORATION',
  NO_PARAMETER_SEARCH_JOB_LIST: 'NO_PARAMETER_SEARCH_JOB_LIST',
  NO_PARAMETER_SEARCH_STARTING_BUSINESS: 'NO_PARAMETER_SEARCH_STARTING_BUSINESS',
  NO_PARAMETER_SEARCH_STARTING_BUSINESS_LIST: 'NO_PARAMETER_SEARCH_STARTING_BUSINESS_LIST',
  NO_PAGE_PARAMETER: 'NO_PAGE_PARAMETER',
  NO_SIGNIN: 'NO_SIGNIN',
  NOT_ADMIN_USER: 'NOT_ADMIN_USER',
  INVALID_PER_PAGE_SEARCH_JOB: 'INVALID_PER_PAGE_SEARCH_JOB',
  INVALID_PER_PAGE_SEARCH_GROUPING_JOB: 'INVALID_PER_PAGE_SEARCH_GROUPING_JOB',
  INVALID_PER_PAGE_SEARCH_COMPANY: 'INVALID_PER_PAGE_SEARCH_COMPANY',
  INVALID_PER_PAGE_SEARCH_CORPORATION: 'INVALID_PER_PAGE_SEARCH_CORPORATION',
  INVALID_PER_PAGE_SEARCH_STARTING_BUSINESS: 'INVALID_PER_PAGE_SEARCH_STARTING_BUSINESS',
  HAS_BASIC_FALSE: 'HAS_BASIC_FALSE',
  HAS_STARTING_BUSINESS_FALSE: 'HAS_STARTING_BUSINESS_FALSE',
  NO_PARAMETER_AGGREGATE_JOB: 'NO_PARAMETER_AGGREGATE_JOB',
}

export const MaxCheckableNumber = 1000 // 求人検索画面でチェック可能な上限数

export const HumanErrorMessages = {
  UNKNOWN: 'エラーが発生しました。',
  DIFFERENT_PASSWORDS: 'パスワードが一致しません。',
  EXPIRED_TOKEN: 'アンロック解除用トークンが有効期限切れです。再度パスワード再発行してください。',
  CHECKED_LIMIT: `${MaxCheckableNumber}件を超えてチェックすることはできません。`,
  FORBIDDEN: 'アクセス権限がありません。',
  PLACE_NOT_FOUND: '検索結果がありませんでした',
  NO_DATA: '取得対象のデータが存在しません。',
  CANNOT_GET_CURRENT_POSITION: '位置情報が取得できないため、現在地取得機能を無効にします。有効にしたい場合は設定を見直してリロードしてください。',
  SEARCH_FAILED: '検索に失敗しました。少し時間をおいて再度お試しください。',
  // 失敗の通知ではなく操作の案内。MessageToast の error スロット（⚠・5秒・同一文言の重複抑止あり）
  // に出すため、info ではなくこちらに置いている。詳細は docs/job_salary_sort_design.md §4.4
  SALARY_SORT_REQUIRES_TYPE: '給与で並べ替えるには、検索条件の「給与」で「すべて」以外（時給・日給・月給・年収）を選んで検索してください。',
}

export const HumanInfoMessages = {
  SUCCESS_UNLOCK: 'アカウントのアンロックが成功しました。',
  SEARCH_CONDITION_DESTROYED: '検索条件が削除されました。',
  JOB_NOTIFICATION_SETTING_DESTROYED: '通知設定が削除されました。',
  DO_DESTROY: '検索条件「%s」を削除します。',
  DO_DESTROY_JOB_NOTIFICATION_SETTING: '通知設定「%s」を削除します。',
  DO_UPDATE_JOB_NOTIFICATION_SETTING: '通知設定を更新しました。',
  ADDED_TO_MYLIST: '求人リストに追加されました。',
  ADDED_TO_STARTING_BUSINESS_LIST: '開業情報リストに追加されました。',
  SUCCESS_COPY_AGGREGATION_CSV: 'クリップボードに集計データをコピーしました。',
  SAVE_COMPANY_COMMENT: 'コメントを更新しました。',
  SAVE_SALES_STATUS: '営業進捗を更新しました。',
  ADD_ACCOUNT_TO_LMT: '営業管理に取引先を追加しました。',
  SAVE_EXCLUSION_COMPANY_NAME: '除外企業を更新しました。',
  ADD_EXCLUSION_COMPANY_NAME: '除外企業に追加しました。',
  SAVE_INCLUSION_COMPANY_NAME: '登録企業を更新しました。',
}

export const Messages = {}

/* Job values */

export const maxKeywords = 50

export const recommendedExcludeKeywords = '塾,医,幼稚園,特別,店,福祉,有限,公益,介,スナック,老人,調理,レジ,キッチン,ホール,スーパー,販売,エンジニア,営業,管理,総合,送迎,受付,事務,土木,建築,建設,溶接,タクシー,ドライバー,士,師'

export const DefaultApplyKeywordsToCatchcopy = 'true'
export const DefaultApplyKeywordsToJobtypeName = 'true'
export const DefaultApplyKeywordsToJobContents = 'true'
export const DefaultApplyKeywordsToQualification = 'true'
export const DefaultApplyKeywordsToCompanyName = 'true'

export const DefaultApplyExcludeKeywordsToCatchcopy = 'true'
export const DefaultApplyExcludeKeywordsToJobtypeName = 'true'
export const DefaultApplyExcludeKeywordsToJobContents = 'true'
export const DefaultApplyExcludeKeywordsToQualification = 'true'
export const DefaultApplyExcludeKeywordsToCompanyName = 'true'

export const acquisitionDates = [
  { code: '0', name: '選択なし' },
  { code: '1', name: '今週' },
  { code: '2', name: '先週' },
  { code: '3', name: '今月' },
  { code: '4', name: 'カレンダーから選択する' },
]

export const DefaultAcquisitionDateCode = '0'
export const DefaultRestrictionAcquisitionDateCode = '1'

export const postingSituations = [
  { code: '0', name: '全て' },
  { code: '1', name: '現在掲載中のみ' },
  { code: '2', name: '2週間以内に終了した求人' },
  { code: '3', name: '3週間以内に終了した求人' },
  { code: '4', name: '4週間以内に終了した求人' },
  { code: '5', name: '2ヶ月以内に終了した求人' },
  { code: '6', name: '3ヶ月以内に終了した求人' },
  { code: '7', name: '6ヶ月以内に終了した求人' },
  { code: '8', name: '1年以内に終了した求人' },
]

export const salaryTypes = [
  { code: '1', name: '時給' },
  { code: '2', name: '日給' },
  { code: '3', name: '月給' },
  { code: '4', name: '年収' },
]

export const salaryValues = {
  0: [
    { code: '', name: '-' },
  ],
  1: [
    { code: '', name: '-' },
    { code: '700', name: '700円' },
    { code: '750', name: '750円' },
    { code: '800', name: '800円' },
    { code: '850', name: '850円' },
    { code: '900', name: '900円' },
    { code: '950', name: '950円' },
    { code: '1000', name: '1000円' },
    { code: '1050', name: '1050円' },
    { code: '1100', name: '1100円' },
    { code: '1200', name: '1200円' },
    { code: '1250', name: '1250円' },
    { code: '1300', name: '1300円' },
    { code: '1400', name: '1400円' },
    { code: '1500', name: '1500円' },
    { code: '1800', name: '1800円' },
    { code: '2000', name: '2000円' },
    { code: '2200', name: '2200円' },
    { code: '2500', name: '2500円' },
    { code: '3000', name: '3000円' },
  ],
  2: [
    { code: '', name: '-' },
    { code: '6500', name: '6500円' },
    { code: '7000', name: '7000円' },
    { code: '7500', name: '7500円' },
    { code: '8000', name: '8000円' },
    { code: '8500', name: '8500円' },
    { code: '9000', name: '9000円' },
    { code: '9500', name: '9500円' },
    { code: '10000', name: '10000円' },
    { code: '11000', name: '11000円' },
    { code: '12000', name: '12000円' },
    { code: '15000', name: '15000円' },
    { code: '20000', name: '20000円' },
  ],
  3: [
    { code: '', name: '-' },
    { code: '150000', name: '15万円' },
    { code: '160000', name: '16万円' },
    { code: '170000', name: '17万円' },
    { code: '180000', name: '18万円' },
    { code: '190000', name: '19万円' },
    { code: '200000', name: '20万円' },
    { code: '210000', name: '21万円' },
    { code: '220000', name: '22万円' },
    { code: '230000', name: '23万円' },
    { code: '240000', name: '24万円' },
    { code: '250000', name: '25万円' },
    { code: '260000', name: '26万円' },
    { code: '270000', name: '27万円' },
    { code: '280000', name: '28万円' },
    { code: '290000', name: '29万円' },
    { code: '300000', name: '30万円' },
    { code: '310000', name: '31万円' },
    { code: '320000', name: '32万円' },
    { code: '330000', name: '33万円' },
    { code: '340000', name: '34万円' },
    { code: '350000', name: '35万円' },
    { code: '360000', name: '36万円' },
    { code: '370000', name: '37万円' },
    { code: '380000', name: '38万円' },
    { code: '390000', name: '39万円' },
    { code: '400000', name: '40万円' },
    { code: '410000', name: '41万円' },
    { code: '420000', name: '42万円' },
    { code: '430000', name: '43万円' },
    { code: '440000', name: '44万円' },
    { code: '450000', name: '45万円' },
    { code: '460000', name: '46万円' },
    { code: '470000', name: '47万円' },
    { code: '480000', name: '48万円' },
    { code: '490000', name: '49万円' },
    { code: '500000', name: '50万円' },
  ],
  4: [
    { code: '', name: '-' },
    { code: '2000000', name: '200万円' },
    { code: '3000000', name: '300万円' },
    { code: '4000000', name: '400万円' },
    { code: '5000000', name: '500万円' },
    { code: '6000000', name: '600万円' },
    { code: '7000000', name: '700万円' },
    { code: '8000000', name: '800万円' },
    { code: '9000000', name: '900万円' },
    { code: '10000000', name: '1000万円' },
    { code: '11000000', name: '1100万円' },
    { code: '12000000', name: '1200万円' },
    { code: '13000000', name: '1300万円' },
    { code: '14000000', name: '1400万円' },
    { code: '15000000', name: '1500万円' },
  ],
}

// 出稿金額
export const budgets = [
  { code: '', name: '-' },
  { code: '0', name: '0万円' },
  { code: '2', name: '2万円' },
  { code: '5', name: '5万円' },
  { code: '10', name: '10万円' },
  { code: '15', name: '15万円' },
  { code: '18', name: '18万円' },
  { code: '20', name: '20万円' },
  { code: '25', name: '25万円' },
  { code: '28', name: '28万円' },
  { code: '35', name: '35万円' },
  { code: '38', name: '38万円' },
  { code: '40', name: '40万円' },
  { code: '44', name: '44万円' },
  { code: '50', name: '50万円' },
  { code: '55', name: '55万円' },
  { code: '60', name: '60万円' },
  { code: '75', name: '75万円' },
  { code: '80', name: '80万円' },
  { code: '85', name: '85万円' },
  { code: '100', name: '100万円' },
  { code: '120', name: '120万円' },
  { code: '144', name: '144万円' },
  { code: '150', name: '150万円' },
  { code: '180', name: '180万円' },
]

export const perPages = [
  { code: '50', name: '50件ずつ表示' },
  { code: '100', name: '100件ずつ表示' },
  { code: '200', name: '200件ずつ表示' },
]

export const DefaultViewEndCode = '1'
export const DefaultSalaryTypeCode = '0'
export const DefaultIntroductionCompany = 'false'
export const DefaultExcludedTemporaryStaffing = 'false'
export const DefaultExcludedNoCompanyTel = 'false'
export const DefaultExcludedNoCompanyUrl = 'false'
export const DefaultOrder = 'acquisition_date'
export const DefaultOrderDirection = 'desc'
export const DefaultSearchJobQuery = {
  viewEndDate: DefaultViewEndCode,
  acquisitionDate: DefaultAcquisitionDateCode,
  selectedIntroductionCompany: DefaultIntroductionCompany,
  excludedTemporaryStaffing: DefaultIntroductionCompany,
  excludedNoCompanyTel: DefaultExcludedNoCompanyTel,
  excludedNoCompanyUrl: DefaultExcludedNoCompanyUrl,
  salaryCd: DefaultSalaryTypeCode,
  order: DefaultOrder,
  orderDirection: DefaultOrderDirection,
}

/* Company & map values */

export const budgetTerms = [
  { code: '1', name: '今月' },
  { code: '2', name: '先月' },
  { code: '3', name: '過去3ヶ月' },
  { code: '4', name: '過去6ヶ月' },
  { code: '5', name: '過去1年' },
]
export const budgetValues = [
  { code: '', name: '-' },
  { code: '10', name: '10万円' },
  { code: '20', name: '20万円' },
  { code: '30', name: '30万円' },
  { code: '40', name: '40万円' },
  { code: '50', name: '50万円' },
  { code: '60', name: '60万円' },
  { code: '70', name: '70万円' },
  { code: '80', name: '80万円' },
  { code: '90', name: '90万円' },
  { code: '100', name: '100万円' },
  { code: '200', name: '200万円' },
  { code: '300', name: '300万円' },
  { code: '400', name: '400万円' },
  { code: '500', name: '500万円' },
  { code: '600', name: '600万円' },
  { code: '700', name: '700万円' },
  { code: '800', name: '800万円' },
  { code: '900', name: '900万円' },
  { code: '1000', name: '1000万円' },
  { code: '1100', name: '1100万円' },
  { code: '1200', name: '1200万円' },
  { code: '1300', name: '1300万円' },
  { code: '1400', name: '1400万円' },
  { code: '1500', name: '1500万円' },
  { code: '1600', name: '1600万円' },
  { code: '1700', name: '1700万円' },
  { code: '1800', name: '1800万円' },
  { code: '1900', name: '1900万円' },
  { code: '2000', name: '2000万円' },
  { code: '2100', name: '2100万円' },
  { code: '2200', name: '2200万円' },
  { code: '2300', name: '2300万円' },
  { code: '2400', name: '2400万円' },
  { code: '2500', name: '2500万円' },
  { code: '2600', name: '2600万円' },
  { code: '2700', name: '2700万円' },
  { code: '2800', name: '2800万円' },
  { code: '2900', name: '2900万円' },
  { code: '3000', name: '3000万円' },
  { code: '3100', name: '3100万円' },
  { code: '3200', name: '3200万円' },
]
export const establishedYears = [
  { code: '', name: '全て' },
  { code: '1', name: '20年以内' },
  { code: '2', name: '10年以内' },
  { code: '3', name: '5年以内' },
  { code: '4', name: '3年以内' },
  { code: '5', name: '今年' },
]
export const publishedRecruitMediaTerms = [
  { code: '1', name: '今月' },
  { code: '2', name: '先月' },
  { code: '3', name: '過去3ヶ月' },
  { code: '4', name: '過去6ヶ月' },
  { code: '5', name: '過去1年' },
]
export const publishedTerms = [
  { code: '1', name: '今月' },
  { code: '2', name: '先月' },
  { code: '3', name: '過去3ヶ月' },
  { code: '4', name: '過去6ヶ月' },
  { code: '5', name: '過去1年' },
]
export const updatedDates = [
  { code: '0', name: '選択なし' },
  { code: '1', name: '今週' },
  { code: '2', name: '先週' },
  { code: '3', name: '今月' },
]

export const DefaultBudgetTerm = '1'
export const DefaultEstablishedYear = ''
export const DefaultPublished = '1'
export const DefaultPublishedRecruitMediaTerm = '1'
export const DefaultPublishedRecruitOrAp = '0'
export const DefaultPublishedTerm = '1'
export const DefaultUpdatedDateCode = '0'
export const DefaultSearchCompanyQuery = {
  updatedDate: DefaultUpdatedDateCode,
  budgetTerm: DefaultBudgetTerm,
  published: DefaultPublished,
  publishedRecruitMediaTerm: DefaultPublishedRecruitMediaTerm,
  publishedRecruitOrAp: DefaultPublishedRecruitOrAp,
  publishedTerm: DefaultPublishedTerm,
}
export const DefaultSearchCorporationQuery = {
  budgetTerm: DefaultBudgetTerm,
  published: DefaultPublished,
  publishedRecruitOrAp: DefaultPublishedRecruitOrAp,
  publishedTerm: DefaultPublishedTerm,
}

export const DefaultSearchStartingBusinessQuery = {
}
export const DefaultSearchDateFrom = '2020-10-01'

export const DefaultMapNeLat = 35.695617610541426
export const DefaultMapSwLat = 35.68306963016018
export const DefaultMapNeLon = 139.71477176251835
export const DefaultMapSwLon = 139.68554641309208
export const DefaultCenterLat = 35.68934386708846
export const DefaultCenterLng = 139.70015908780522
export const DefaultZoom = 16
export const DefaultPerPage = 300
export const DefaultSearchMapQuery = {
  updatedDate: DefaultUpdatedDateCode,
  budgetTerm: DefaultBudgetTerm,
  published: DefaultPublished,
  publishedRecruitMediaTerm: DefaultPublishedRecruitMediaTerm,
  publishedRecruitOrAp: DefaultPublishedRecruitOrAp,
  publishedTerm: DefaultPublishedTerm,
  mapNeLat: DefaultMapNeLat,
  mapSwLat: DefaultMapSwLat,
  mapNeLon: DefaultMapNeLon,
  mapSwLon: DefaultMapSwLon,
  centerLat: DefaultCenterLat,
  centerLng: DefaultCenterLng,
  zoom: DefaultZoom,
  perPage: DefaultPerPage,
}

/* Aggregation values */

export const searchKeywordTargets = [
  { code: '0', name: '職種' },
  { code: '1', name: '業種' },
  { code: '2', name: 'その他' },
]

export const searchAddressTargets = [
  { code: '0', name: '出稿元' },
  { code: '1', name: '勤務地' },
]

export const DefaultAggregateJobQuery = {
  salaryCd: '0',
  rangeType: '2',
  aggType: '1',
  verticalAxis: '1',
  prefectureCd: '13',
  employmentCd: '1',
}

export const aggSalaryTypes = [
  { code: '1', name: '時給' },
  { code: '3', name: '月給' },
  { code: '4', name: '年収' },
]

export const aggTypes = [
  { code: '1', name: '求人数' },
  { code: '2', name: '給与' },
  { code: '3', name: '出稿予算' },
]

export const aggVerticalAxis = [
  { code: '1', name: '市区町村' },
  { code: '2', name: '職種' },
  { code: '3', name: '業種' },
  { code: '4', name: '掲載メディア' },
  { code: '5', name: '都道府県' },
]

export const aggrangeTypes = [
  { code: '1', name: '週次' },
  { code: '2', name: '月次' },
]

export const geoDistanceValues = [
  { code: '', name: '選択なし' },
  { code: '300', name: '300m' },
  { code: '500', name: '500m' },
  { code: '800', name: '800m' },
  { code: '1000', name: '1km' },
  { code: '1500', name: '1.5km' },
  { code: '2000', name: '2km' },
  { code: '2500', name: '2.5km' },
  { code: '3000', name: '3km' },
  { code: '5000', name: '5km' },
  { code: '10000', name: '10km' },
  { code: '15000', name: '15km' },
  { code: '20000', name: '20km' },
  { code: '25000', name: '25km' },
  { code: '30000', name: '30km' },
]



// WEBPACK FOOTER //
// ./src/constants.js